import { AnyAction } from 'redux';
import {
  ENABLE_CLOSED_CAPTIONING,
  DISABLE_CLOSED_CAPTIONING,
} from 'actions/closedCaptioning';

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action: AnyAction): boolean => {
  switch (action.type) {
    case ENABLE_CLOSED_CAPTIONING:
      return true;
    case DISABLE_CLOSED_CAPTIONING:
      return false;
    default:
      return state;
  }
};
